import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

jQuery(document).ready(function($) {
    gsap.registerPlugin(ScrollTrigger);

    // Target del container principale per l'animazione
    $(".section-animate").each(function() {
        let container = this;
        
        // Verifica se il container è un discendente di '.single-post__content'
        if ($(container).parents('.single-post__content').length > 0) {
            // console.log('dentro post');
            return; // Se il container è dentro '.single-post__content', salta questo container
        }

        // console.log('fuori post');
        let animElements = $(container).find(".element-animate"); // Trova tutti gli elementi da animare

        // Configura un ScrollTrigger per l'intero container
        ScrollTrigger.create({
            trigger: container,
            start: "+150px bottom", // Inizio 
            onEnter: () => animateElements(animElements), // Funzione di animazione chiamata all'ingresso
            once: true // Assicura che l'animazione si attivi solo una volta
        });
    });

    function animateElements(elements) {
        elements.each(function(index, element) {
            gsap.fromTo(element, {
                opacity: 0, // Inizia invisibile
                y: 50 // Parte leggermente spostato verso il basso
            }, {
                opacity: 1,
                y: 0,
                duration: 3,
                delay: index * 0.3,
                ease: "power2.out" // Aggiunge un easing per una transizione più morbida
            });
        });
    }

    // function animateElements(elements) {
    //     elements.each(function(index, element) {
    //         // Controlla se l'elemento è dentro a '.single-post__content'
    //         if ($(element).closest('.single-post__content').length > 0) {
    //             return; // Salta questo elemento
    //         }
    
    //         // Altrimenti, procedi con l'animazione
    //         gsap.fromTo(element, {
    //             opacity: 0,
    //             y: 50,
    //         }, {
    //             opacity: 1,
    //             y: 0,
    //             duration: 3,
    //             delay: index * 0.3,
    //             ease: "power2.out" // Aggiunge un easing per una transizione più morbida
    //         });
    //     });
    // }
    

});



document.addEventListener('DOMContentLoaded', function() {
    // Breve timeout per assicurarsi che tutti gli elementi siano caricati
    setTimeout(() => {
        document.body.classList.add('site-load');
    }, 100);
});

// Alternativa che aspetta anche il caricamento delle immagini
window.addEventListener('load', function() {
    document.body.classList.add('site-load');
});


document.addEventListener('DOMContentLoaded', function() {
    // Verifica se siamo in home
    if (document.body.classList.contains('home') && !document.body.classList.contains('woocommerce-js')) {
        const header = document.querySelector('header');
        
        // Imposta lo stato iniziale
        if (header) {
            header.style.opacity = '0';
            
            // Anima dopo un breve delay
            setTimeout(() => {
                header.style.transition = 'opacity 1s ease-out';
                header.style.opacity = '1';
                
                // Rimuovi la transition dopo l'animazione
                header.addEventListener('transitionend', () => {
                    header.style.transition = '';
                }, { once: true });
            }, 1000);
        }
    }
});



// function imgParallax() {

//     try {
//         const parallax = document.querySelectorAll('.img-parallax')
    
//         new Ukiyo(parallax, {
//             scale: 1.2, // 1~2 is recommended
//             speed: 1.2, // 1~2 is recommended
//             willChange: true, // This may not be valid in all cases
//             wrapperClass: "img-parallax-wrapper",
//             externalRAF: false
//         })
    
//       } catch(e) {
//         console.log(e)
//       }


// }

// imgParallax();

function imgParallax() {
    try {
        gsap.registerPlugin(ScrollTrigger);

        gsap.utils.toArray('.img-parallax').forEach(function(image) {
            image.onload = () => {
                const heroContainer = image.closest('.hero-img-bg');
                
                if (heroContainer) {
                    // Caso hero: usa il container come wrapper e aumenta l'altezza dell'immagine
                    const height = heroContainer.offsetHeight;
                    const extraHeight = height * 0.12; // 12% extra per il movimento
                    
                    heroContainer.style.overflow = 'hidden';
                    
                    image.style.width = '100%';
                    image.style.height = (height + extraHeight) + 'px';
                    image.style.objectFit = 'cover';
                    image.style.marginTop = (-extraHeight / 2) + 'px';

                    let tl = gsap.timeline({
                        scrollTrigger: {
                            trigger: heroContainer,
                            scrub: true,
                            pin: false,
                        }
                    });

                    tl.from(image, {
                        yPercent: -6,
                        ease: "none",
                    }).to(image, {
                        yPercent: 6,
                        ease: "none",
                    });
                } else {
                    // Caso normale: crea un wrapper come prima
                    const originalHeight = image.offsetHeight;
                    const parallaxDistance = originalHeight * 0.12;
                    
                    const wrapper = document.createElement('div');
                    wrapper.classList.add('img-parallax-wrapper');
                    wrapper.style.overflow = 'hidden';
                    wrapper.style.height = (originalHeight - parallaxDistance) + 'px';
                    
                    image.style.width = '100%';
                    image.style.objectFit = 'cover';
                    image.style.marginTop = (-parallaxDistance / 2) + 'px';
                    
                    image.parentNode.insertBefore(wrapper, image);
                    wrapper.appendChild(image);

                    let tl = gsap.timeline({
                        scrollTrigger: {
                            trigger: wrapper,
                            scrub: true,
                            pin: false,
                        }
                    });

                    tl.from(image, {
                        yPercent: -6,
                        ease: "none",
                    }).to(image, {
                        yPercent: 6,
                        ease: "none",
                    });
                }
            };

            if (image.complete) {
                image.onload();
            }
        });

    } catch(e) {
        console.log(e);
    }
}

imgParallax();





function creaEffettoParallasse() {
    const classiParallasse = {
        'parallasse-lento': 0.15,
        'parallasse-medio': 0.25,
        'parallasse-veloce': 0.4
    };

    Object.entries(classiParallasse).forEach(([classe, velocita]) => {
        const immagini = document.querySelectorAll(`.${classe}`);
        // console.log(`Immagini ${classe} trovate:`, immagini.length);

        immagini.forEach((immagine, index) => {
            const container = immagine.parentElement;
            // console.log(`Immagine ${classe} ${index + 1} - Velocità:`, velocita);

            gsap.to(immagine, {
                yPercent: () => {
                    const distance = (container.offsetHeight - immagine.offsetHeight);
                    // console.log(`Immagine ${classe} ${index + 1} - Distanza di movimento:`, distance);
                    return velocita * 100;
                },
                ease: "none",
                scrollTrigger: {
                    trigger: container,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: 1,
                    markers: false,
                    // onEnter: () => console.log(`ScrollTrigger ${classe} ${index + 1} entrato`),
                    // onLeave: () => console.log(`ScrollTrigger ${classe} ${index + 1} uscito`),
                    // onUpdate: (self) => {
                    //     console.log(`ScrollTrigger ${classe} ${index + 1} progresso:`, self.progress.toFixed(2));
                    // }
                }
            });
        });
    });
}

// Assicuriamoci che GSAP e ScrollTrigger siano caricati
if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    console.error('GSAP o ScrollTrigger non sono caricati correttamente');
} else {
    gsap.registerPlugin(ScrollTrigger);
    
    // Esegui la funzione quando il DOM è completamente caricato
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', creaEffettoParallasse);
    } else {
        creaEffettoParallasse();
    }
}

// Ricalcola l'effetto al ridimensionamento della finestra
window.addEventListener('resize', creaEffettoParallasse);
